import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';

export interface BookingPaymentTermsRow {
  id: number;
  institution_id: number;
  title: string;
  text: string;
  canx_allowed_hours_before_start: number | null;
  no_canx_refund: boolean;
}

export const BookingPaymentTerms: Entity<BookingPaymentTermsRow> = {
  id: 'BookingPaymentTerms',
  title: 'Booking Payment Terms',
  service: 'main',
  rowLabel: (row: BookingPaymentTermsRow) => row.title,
  // rowLabelDynamic: (row: BookingPaymentTermsRow) => `<lookup:Institution:${row.institution_id}>`,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.booking_payment_terms',
  },
  security: [
    { role: 'all-authed', action: 'read', access: 'all' },
    { role: 'admin', action: 'all', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['institution_id', 'ASC']],
  defaultFilters: [{ fieldId: 'institution_id', operator: 'eq', value: '' }],
  listRowLink: '/admin/event-profile/display-payment-terms/{key}',
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      autoIncrement: true,
    },
    institution_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Institution',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      listColumn: true,
      refEntity: Institution,
    },
    title: {
      seq: 15,
      type: FieldType.Text,
      label: 'Title',
      mandatory: true,
      listColumn: true,
      fieldGroup: 'shown',
      maxLength: 200,
    },
    text: {
      seq: 20,
      type: FieldType.Text,
      label: 'Text',
      mandatory: true,
      listColumn: true,
      fieldGroup: 'shown',
      formColumnWidths: { md: 9 },
      description: 'A short summary of the cancellation terms defined',
      defaultVal:
        'You can cancel up to CANX_ALLOWED_HOURS_BEFORE_START hours before the event starts for a refund of the ticket price EXCLUDING booking fees. Cancellations made after then will not be refunded. If the event is cancelled by the organiser, you will receive a full refund including booking fees.',
    },
    canx_allowed_hours_before_start: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Cancellation Allowed Hours Before Start',
      description:
        'Number of hours before event start that cancellation is allowed for a refund (must contain either CANX_ALLOWED_HOURS_BEFORE_START or CANX_ALLOWED_DAYS_BEFORE_START in the text)',
      mandatory: false,
      listColumn: true,
      fieldGroup: 'shown',
    },
    no_canx_refund: {
      seq: 35,
      type: FieldType.Boolean,
      label: 'No Cancellation Refund',
      description: 'Indicates whether no refund is given for cancellations',
      mandatory: true,
      listColumn: true,
      fieldGroup: 'shown',
    },
  },
};
